import { FC, ReactNode } from 'react';
import { UserRole } from '../../utils';
import { useUserStore } from '../../stores';

interface RoleRouterProps {
	dealerComponent?: ReactNode;
	shopkeeperComponent?: ReactNode;
	adminComponent?: ReactNode;
}

const RoleRouter: FC<RoleRouterProps> = ({ dealerComponent, shopkeeperComponent, adminComponent }) => {
	const { user } = useUserStore();

	if (user?.grupoAcesso.id.toString() === UserRole.Dealer) {
		return <>{dealerComponent}</>;
	}

	if (user?.grupoAcesso.id.toString() === UserRole.Shopkeeper) {
		return <>{shopkeeperComponent}</>;
	}

	if (user?.grupoAcesso.id.toString() === UserRole.Admin) {
		return <>{adminComponent}</>;
	}

	return null;
};

export default RoleRouter;
